import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../_services';

@Component({ templateUrl: 'login.component.html' })
export class AuthLoginComponent implements OnInit {

    captchaKey = '6LcNppMUAAAAAI_BXwtLjYe6JzHOILLJ7Q5ZA2Bm';
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    error = '';

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService
    ) { 
        if (this.authenticationService.currentUserValue) { 
            this.router.navigate(['/']);
        }
    }

    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required],
            customer: ['', Validators.required],
            // recaptcha: ['', Validators.required]
        });

        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    get f() { return this.loginForm.controls; }

    handleCaptcha(event) {
        console.log(event);
        
    }

    onSubmit() {
        this.submitted = true;
        if (this.loginForm.invalid) return;

        this.loading = true;
        this.authenticationService.login(this.f.username.value, this.f.password.value, this.f.customer.value).subscribe(
            user => {
                if (user && user.isSuccess()) this.router.navigate([this.returnUrl]);
                else {
                    this.error = 'خطا';
                    this.loading = false;
                }
            },
            error => {
                this.error = error;
                this.loading = false;
            }
        )
    }
}